var angularModule = angular.module('octopusApp.projects');
var _ = require('underscore');

module.exports = function ($scope, octopusRepository, pluginRegistry, currentStep, currentAction, $uibModalInstance) {
    $scope.features = [];
    $scope.close = closeModal;
    $scope.save = save;
    $scope.featureToggled = featureToggled;
    $scope.removedFeatures = [];

    var actionType = pluginRegistry.getDeploymentAction(currentAction.ActionType);
    var allFeatures = pluginRegistry.getAllFeatures();
    var enabledFeatures = [];

    function init(){
        if (currentAction.Properties["Octopus.Action.EnabledFeatures"]) {
            enabledFeatures = currentAction.Properties["Octopus.Action.EnabledFeatures"].split(',');
        }

        if (actionType.features && actionType.features.optional) {
            allFeatures.forEach(function (feature) {
                if (!_.contains(actionType.features.optional, feature.featureName)) {
                    return;
                }

                $scope.features.push({
                    featureName: feature.featureName,
                    title: feature.title,
                    description: feature.description,
                    instance: feature,
                    isEnabled: _.contains(enabledFeatures, feature.featureName),
                    wasEnabled: _.contains(enabledFeatures, feature.featureName)
                });
            });
        }
    }

    function featureToggled() {
        $scope.removedFeatures = $scope.features.filter(function(feature){
            return feature.wasEnabled && !feature.isEnabled;
        }).map(function(feature){
            return feature.title;
        });
    }

    function closeModal() {
        $uibModalInstance.close();
    }

    function save() {
        var currentlyEnabled;
        // permanent actions are always enabled
        if (actionType.features && actionType.features.permanent) {
            currentlyEnabled = actionType.features.permanent;
        } else {
            currentlyEnabled = [];
        }

        $scope.features.forEach(function (feature) {
            if (feature.isEnabled) {
                currentlyEnabled.push(feature.featureName);
            }

            if (feature.wasEnabled && !feature.isEnabled) {
                //need to delete the data for this feature
                feature.instance.disable(currentAction, currentStep);
            }

            if (!feature.wasEnabled && feature.isEnabled) {
                if (feature.instance.enable) {
                    feature.instance.enable(currentAction, currentStep);
                }
            }
        });
        currentAction.Properties["Octopus.Action.EnabledFeatures"] = currentlyEnabled.join(',');
        $uibModalInstance.close(true);
    }

    init();
}

angularModule.controller('ProjectProcessFeaturesController', module.exports);



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_process_features_controller.js
// module id = 8460271919744406
// module chunks = 1